import React, { useEffect, useState } from 'react';
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";
import { Helmet } from 'react-helmet-async';

function EmpPackagesPage() {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dataTable, setDataTable] = useState(null);

    // Function to initialize or reinitialize DataTable
    const initializeDataTable = () => {
        const $ = window.$;
        if (!$ || !$.fn.DataTable) {
            console.log('jQuery or DataTable not loaded');
            return;
        }

        try {
            // Destroy existing instance if it exists
            if ($.fn.DataTable.isDataTable('#messages_table')) {
                $('#messages_table').DataTable().destroy();
                $('#messages_table').empty();
            }

            // Clear any existing event listeners
            $('#messages_table').off();

            return $('#messages_table').DataTable({
                responsive: true,
                pageLength: 10,
                order: [[0, 'desc']],
                stateSave: true,  // Save the state of the table
                processing: true,  // Show processing indicator
                deferRender: true, // Improve performance
                language: {
                    search: "Search:",
                    searchPlaceholder: "Search messages...",
                    emptyTable: "No messages available",
                    zeroRecords: "No matching messages found",
                    info: "Showing _START_ to _END_ of _TOTAL_ messages",
                    infoEmpty: "Showing 0 messages",
                    processing: "Loading messages..."
                },
                columnDefs: [
                    { orderable: false, targets: [5] }, // Message column not sortable
                    { 
                        targets: [5],
                        render: function(data) {
                            // Truncate long messages and add tooltip
                            if (data && data.length > 50) {
                                return `<span title="${data}">${data.substring(0, 50)}...</span>`;
                            }
                            return data || '';
                        }
                    }
                ],
                drawCallback: function() {
                    // Reinitialize tooltips
                    $('[data-bs-toggle="tooltip"]').tooltip();
                }
            });
        } catch (error) {
            console.error('Error initializing DataTable:', error);
            return null;
        }
    };

    const fetchMessages = async () => {
        try {
            setLoading(true);
            const res = await axiosInstance.get(`${API_URL}/admin/getAllMessages`);
            if (res.data.status === 200) {
                setMessages(res.data.data);
            }
        } catch (err) {
            console.error("Failed to fetch messages", err);
        } finally {
            setLoading(false);
        }
    };

    // Effect for fetching data
    useEffect(() => {
        fetchMessages();
        
        // Cleanup on unmount
        return () => {
            const $ = window.$;
            if ($ && $.fn.DataTable) {
                try {
                    const table = $('#messages_table').DataTable();
                    if (table) {
                        table.destroy();
                        $('#messages_table').empty();
                    }
                } catch (error) {
                    console.error('Error during cleanup:', error);
                }
            }
        };
    }, []);

    // Effect for initializing DataTable
    useEffect(() => {
        if (!loading && messages.length > 0) {
            // Wait for DOM update
            const timer = setTimeout(() => {
                const dt = initializeDataTable();
                if (dt) {
                    setDataTable(dt);
                    // Force redraw after a short delay
                    setTimeout(() => {
                        dt.columns.adjust().draw();
                    }, 50);
                }
            }, 200);

            return () => {
                clearTimeout(timer);
                const $ = window.$;
                if ($ && $.fn.DataTable) {
                    try {
                        if ($.fn.DataTable.isDataTable('#messages_table')) {
                            const table = $('#messages_table').DataTable();
                            table.destroy();
                            $('#messages_table').empty();
                        }
                        setDataTable(null);
                    } catch (error) {
                        console.error('Error cleaning up DataTable:', error);
                    }
                }
            };
        }
    }, [loading, messages]);

    // Effect to handle cleanup when component unmounts
    useEffect(() => {
        return () => {
            const $ = window.$;
            if ($ && $.fn.DataTable) {
                try {
                    const tables = $.fn.dataTable.tables({ visible: true, api: true });
                    tables.forEach(table => {
                        if (table) {
                            table.destroy();
                        }
                    });
                    $('#messages_table').empty();
                    setDataTable(null);
                } catch (error) {
                    console.error('Error during final cleanup:', error);
                }
            }
        };
    }, []);

    return (
        <>
            <Helmet>
                <title>Supports | Job Contact</title>
                <meta name="description" content="Welcome to the home page of MyApp." />
            </Helmet>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Support</h2>
                <div className="breadcrumbs"><a href="#">Home</a><a href="#">Dashboard</a><span>Support</span></div>
            </div>
            <div className="panel panel-default site-bg-white m-t30">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" />Supports</h4>
                </div>
                <div className="panel-body wt-panel-body">
                    <div className="p-a20 table-responsive">
                        {loading ? (
                            <div className="text-center p-3">Loading messages...</div>
                        ) : (
                            <table id="messages_table" className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>User Name</th>
                                        <th>Email</th>
                                        <th>Phone No</th>
                                        <th>Subject</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {messages.map((message, idx) => (
                                        <tr key={message.id || idx}>
                                            <td>{message.id || ""}</td>
                                            <td>{message.name || "N/A"}</td>
                                            <td>{message.email || "N/A"}</td>
                                            <td>{message.phone || "N/A"}</td>
                                            <td>{message.subject || "N/A"}</td>
                                            <td>{message.message || "N/A"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Id</th>
                                        <th>User Name</th>
                                        <th>Email</th>
                                        <th>Phone No</th>
                                        <th>Subject</th>
                                        <th>Message</th>
                                    </tr>
                                </tfoot>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default EmpPackagesPage;